import { useContext, useEffect, useState } from "react";
import "../../personaliza-styles.css"
import "./CardModel.css";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "@material-ui/core";
import Container from "react-bootstrap/Container";
import { Server } from "../../../../constants";
import { DataContext } from "../../../pages/ConfiguraHyundai";
import axios from "axios";


const CardModel = (props) => {

    const [catalogo, setCatalogo] = useState([]);
    const {
        step,
        setStep,
        setModeloSeleccionado
    } = useContext(DataContext);

    useEffect(() => {
        axios.get(Server + "/api/vehiculos/getListAutosWeb")
            .then(res => setCatalogo(res.data.data))
            .catch(err => console.log(err));
    }, []);

    const getImagenCatalogo = (codigo) => {
        let imagen = null;

        catalogo.forEach((grupo) => {
            grupo.MOD_LISTA_AUTOS.forEach((lista) => {
                lista.forEach((auto) => {
                    if (Number(auto.MOD_CODIGO) === Number(codigo)) {
                        imagen = auto.MOD_FOTO_PRINCIPAL;
                    }
                });
            });
        });

        return imagen;
    };

    return (
        <Container fluid>
            <Row
                className='centrar-global'
                style={{ paddingLeft: '5%', paddingRight: '5%' }}
            >
                {props.listaModelos?.map((car) => (
                    <Col key={car.CM_ID} xl={3} lg={3} md={6} xs={12} className='px-4'>
                        <Card className="cardModel"
                            onClick={() => {
                                setModeloSeleccionado(car);
                                setStep(step + 1);
                            }
                            }>
                            <div className="centrar-global pt-3">
                                <img className="image-zoom"
                                    src={getImagenCatalogo(car.MOD_CODIGO)}
                                    alt={car.MOD_NOMBRE}
                                />
                            </div>
                            <div className="alinear-vertical">
                                <div>
                                    {car?.MOD_NOMBRE ?
                                        <>
                                            <h1>
                                                <p className="h18 h-txt-r mr-2">
                                                    <b>{car?.MOD_NOMBRE} </b>
                                                    {/*{car?.CM_ANIO}*/}
                                                </p>
                                                <p className="h-text-black h18">{car.CM_DESCRIPCION}</p>
                                            </h1>
                                        </>
                                        :
                                        <h1><b
                                            className="h18 h-txt-r mr-2"
                                        >Próximamente</b>
                                            <span className="h18 h-txt-r">{car?.CM_ANIO}</span>
                                            <p className="h-text-black h18">Próximamente</p>
                                        </h1>
                                    }
                                    {/*
                                    <span className="h14 h-head-l">Desde: </span>
                                    <br />
                                    {
                                        car.MOD_CODIGO ?
                                            <span
                                                className="h20 h-txt-r">{car.CM_PRECIO_BASE.toLocaleString('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD'
                                                })} </span>
                                            :
                                            <span className="h20 h-txt-r">$ xx,xxx</span>
                                    }*/}
                                </div>
                                <div>
                                    <Button
                                        disabled={!car.MOD_CODIGO}
                                        className="btn-main"
                                        onClick={() => {
                                            setModeloSeleccionado(car);
                                            setStep(step + 1);
                                        }
                                        }
                                    >
                                        Configúralo
                                    </Button>
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};
export default CardModel;